<template>
  <div class="controlPanel">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="坏件登记" name="first">
          <span class="childTabs activeLink">登记列表</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-checkbox
              class="myOrderCheckbox"
              v-model="myOrderActive"
              @change="myOrderChange"
              >我登记的</el-checkbox
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              style="margin-left: 15px"
              @click="registerBtn"
              >登记</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        v-if="isMoreSearch"
      >
        <div class="searchConditionBox">
          <el-form-item label="配件SN" size="small">
            <el-input
              v-model="searchForm.sn"
              placeholder="坏件SN或更换后的SN"
              clearable
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="配件类型" size="small">
            <el-select
              v-model="searchForm.partType"
              placeholder="选择配件类型"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in partTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主机SN" size="small">
            <el-input
              v-model="searchForm.deviceSn"
              placeholder="输入主机SN"
              clearable
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="工单号" size="small">
            <el-select
              v-model="searchForm.productionOrderId"
              placeholder="选择组装工单"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'productionOrder', '组装工单', 'searchForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderList"
                :key="index"
                :label="item.orderNumber"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登记维修" size="small">
            <el-select
              v-model="searchForm.userId"
              placeholder="登记或维修人员"
              filterable
              clearable
              :disabled="myOrderActive"
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'user', '员工选择', 'searchForm')"
              @change="onUserChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="rightContent">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="partSn"
            label="坏件SN"
            min-width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.partSn">{{ scope.row.partSn }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="type.title"
            label="配件类型"
            min-width="80"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type && scope.row.type.title">{{ scope.row.type.title }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="productionOrder.orderNumber"
            label="工单号"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.productionOrder && scope.row.productionOrder.orderNumber">{{ scope.row.productionOrder.orderNumber }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="device.sn"
            label="主机SN"
            min-width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.device && scope.row.device.sn">{{ scope.row.device.sn }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="product.code"
            label="产品型号"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.product && scope.row.product.code">{{ scope.row.product.code }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createDateTime"
            label="登记时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createDateTime">{{ scope.row.createDateTime }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createUser"
            label="登记人"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createUser">{{ scope.row.createUser.name }}({{ scope.row.createUser.employeeNum }})</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="newSn"
            label="更换后的SN"
            min-width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.newSn">{{ scope.row.newSn }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastUpdateDateTime"
            label="维修时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.lastUpdateDateTime">{{ scope.row.lastUpdateDateTime }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastUpdateUser"
            label="维修人"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.lastUpdateUser">{{ scope.row.lastUpdateUser.name }}({{ scope.row.lastUpdateUser.employeeNum }})</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getTableData"
        ></pagination>
      </div>
    </div>
    <myDialog
      ref="registerDialog"
      title="坏件登记"
      width="500px"
      @submitData="submitRegister"
      @dialogClose="registerDialogClose"
    >
      <template slot="content">
        <el-form
          ref="registerForm"
          :model="registerForm"
          :rules="registerRules"
          :label-width="labelWidth"
        >
          <el-form-item label="配件类型" size="small" prop="partType">
            <el-select
              v-model="registerForm.partType"
              placeholder="选择配件类型"
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in partTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="坏件SN" size="small" prop="partSnText">
            <el-input
              type="textarea"
              v-model="registerForm.partSnText"
              :rows="12"
              placeholder="请输入坏件SN，每行一个"
            ></el-input>
            <div class="sn-count">已输入 {{ snCount }} 个SN</div>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import { apiPartTypeList, apiRegisterDefective, apiSearchDefective } from "@/api/badPartsOrder.js";
import { apiProductTypeList, apiProductList } from "@/api/customerOrder.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/badPartsOrder" },
  components: {
    pagination,
    myDialog,
    orderTableSelect,
  },
  data() {
    return {
      isMoreSearch: false,
      searchForm: {},
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
        beginIndex: 1,
        endIndex: 0,
      },
      pullDownData: {
        productTypeList: [],
        productList: [],
        userList: [],
        productionOrderList: [],
      },
      partTypeList: [],
      registerForm: {
        partType: "",
        partSnText: "",
      },
      registerRules: {
        partType: [
          { required: true, message: "请选择配件类型", trigger: "change" },
        ],
        partSnText: [
          { required: true, message: "请输入坏件SN", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
      myOrderActive: false,
    };
  },
  computed: {
    snCount() {
      if (!this.registerForm.partSnText) return 0;
      return this.registerForm.partSnText
        .split("\n")
        .map((s) => s.trim())
        .filter((s) => s).length;
    },
  },
  methods: {
    // 我登记的
    myOrderChange() {
      this.searchForm.userId = this.myOrderActive
        ? this.$store.state.userId
        : null;
      if (this.myOrderActive) {
        this.pullDownData.userList = [];
      }
      this.pagination.currentPage = 1;
      this.getTableData();
    },
    // 登记人选择变化时取消勾选“我登记的”
    onUserChange() {
      if (this.myOrderActive) {
        this.myOrderActive = false;
      }
    },
    // 打开登记弹窗
    registerBtn() {
      this.getPartTypeList();
      this.$refs.registerDialog.dialogVisible = true;
    },
    // 获取配件类型列表
    async getPartTypeList() {
      const res = await apiPartTypeList();
      if (res.code == 0) {
        this.partTypeList = res.data;
      }
    },
    // 提交登记
    submitRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          const partSnArr = this.registerForm.partSnText
            .split("\n")
            .map((s) => s.trim())
            .filter((s) => s);
          if (partSnArr.length === 0) {
            this.$message({ type: "warning", message: "请输入至少一个坏件SN" });
            return;
          }
          const res = await apiRegisterDefective({
            partType: this.registerForm.partType,
            partSn: partSnArr,
          });
          if (res.code == 0) {
            this.$refs.registerDialog.dialogVisible = false;
            this.$message({ type: "success", message: "登记成功" });
            this.getTableData();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭登记弹窗
    registerDialogClose() {
      const savedPartType = this.registerForm.partType;
      this.$refs.registerForm.resetFields();
      this.registerForm = { partType: savedPartType, partSnText: "" };
    },
    // 产品类别改变
    productTypeChange(value) {
      this.$set(this.searchForm, "productId", null);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value);
      }
    },
    // 获取产品类别列表
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 获取产品型号列表
    async getProductList(productType) {
      const res = await apiProductList({ productType });
      if (res.code == 0) {
        this.pullDownData.productList = res.data;
      }
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {
      this.pagination.currentPage = 1;
      this.searchForm = {};
      this.getTableData();
    },
    // 确认查询
    onSearch() {
      this.pagination.currentPage = 1;
      this.getTableData();
    },
    // 获取表格数据
    async getTableData() {
      this.tableData = [];
      const params = {
        ...this.searchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      if (this.myOrderActive) {
        params.isMy = true;
      }
      const res = await apiSearchDefective(params);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getTableData();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getTableData();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    this.getPartTypeList();
    this.getProductTypeList();
    this.getTableData();
  },
  deactivated() {
    window.onresize = "";
  },
};
</script>

<style lang="less" scoped>
.sn-count {
  font-size: 12px;
  color: var(--textSecondary);
  margin-top: 4px;
}
</style>
